var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 69,
    viewBox: "0 0 71 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1113 0L58 12.8887V22.8242C55.065 21.648 51.8594 21 48.5 21C39.6235 21 31.8186 25.5168 27.2529 32.3809C22.7417 33.2005 19.3331 37.1367 19.333 41.8887C19.333 45.0537 20.8458 47.8571 23.1885 49.6191C23.5512 52.6037 24.4288 55.4272 25.7285 58H6.44434C2.86776 57.9999 5.76122e-05 55.1 0 51.5557V6.44434C5.86426e-05 2.89998 2.86776 5.87657e-05 6.44434 0H45.1113ZM6.44434 6.44434V19.333H38.667V6.44434H6.44434Z",
    fill: "#10D070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 24C36.08 24 26 34.08 26 46.5C26 58.92 36.08 69 48.5 69C60.92 69 71 58.92 71 46.5C71 34.08 60.92 24 48.5 24ZM44 57.75L32.75 46.5L35.9225 43.3275L44 51.3825L61.0775 34.305L64.25 37.5L44 57.75Z",
    fill: "#10D070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveSuccess);
export default __webpack_public_path__ + "static/media/saveSuccess.5e97f86263c34a4b7d08f34f017552f2.svg";
export { ForwardRef as ReactComponent };